<template>
  <div>
    <template v-if="place.checkIn !== undefined || isFlight()">
      <plan-date
        :isDeparture="false"
        :isHighlight="true"
        :date="routeArrivalDate"
        :inJapan="inJapan()" />
    </template>
    <template v-else>
      <plan-date
        :isDeparture="false"
        :isHighlight="false"
        :date="routeArrivalDate"
        :inJapan="inJapan()" />
    </template>
    <div class="course-place text-btn_secondary border" :class="{lock: editable && place.lock, 'in-japan': inJapan() }">
      <div class="course-time text-right font-bold">
        <p>{{ routeArrivalTime }}</p>
        <p>{{ nextDepartureTime }}</p>
      </div>
      <div class="course-place-info">
        <div class="course-place-info-inner">
          <div class="course-place-info-number w-6 h-6 text-center border font-bold text-white flex-shrink-0">
            {{ routeIndex + 1 }}
          </div>
          <div class="course-name text-body text-lg font-bold">
            {{ place.name }}
          </div>
          <div class="plan-icon ml-1 mr-2">
            <a @click="showMap">
              <img src="@/assets/images/icon-plan-map.svg" alt="マップ" />
            </a>
          </div>
        </div>
        <p class="course-visit text-btn_secondary mt-1 ml-3">
          {{ visitTime }}
        </p>
      </div>
      <div v-if="editable && (!place.lock || place.changeVisit)" class="button-edit relative text-link">
        <place-button :action="toggleEditMenu" :name="$t('edit_label')" />
        <edit-menu
          v-show="showEditMenu"
          :place="place"
          @changeVisit="onChangeVisit"
          @deleteDestination="onDeleteDestination" />
      </div>
    </div>
    <template v-if="place.checkIn !== undefined">
      <plan-date
        :isDeparture="true"
        :isHighlight="true"
        :date="nextDepartureDate"
        :inJapan="inJapan()" />
    </template>
  </div>
</template>

<script>
import PlaceButton from "../atoms/PlaceButton"
import EditMenu from "./EditMenu"
import PlanDate from "../molecules/PlanDate"
import _ from 'lodash'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    PlaceButton,
    EditMenu,
    PlanDate
  },
  props: {
    place: {
      type: Object,
      required: true
    },
    changeVisit: {
      type: Function,
      default: function () {
        return {}
      }
    },
    deleteDestination: {
      type: Function,
      default: function () {
        return {}
      }
    },
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    route: {
      type: Object,
      required: true
    },
    next: {
      type: Object,
      default: function () {
        return {}
      }
    },
    routeIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showEditMenu: false
    }
  },
  computed: {
    visitTime: function () {
      const time = this.place.visit
      return `${this.$t('residence_time_label')}：` + (time / 60 >= 1 ? Math.floor(time / 60) + this.$t('hour_label') : "") + (time % 60 !== 0 ? time % 60 + this.$t('minute_label') : "");
    },
    routeArrivalTime: function () {
      if (this.place.checkIn !== undefined) {
        const t = moment(this.place.checkIn)
        return t.format("HH:mm")
      } else {
        const t = this.route.arrivalTime
        return t.format("HH:mm")
      }
    },
    nextDepartureTime: function () {
      if (this.place.checkIn !== undefined) {
        const t = moment(this.place.checkIn).add(this.place.visit, 'minutes')
        return t ? t.format("HH:mm") : ''
      } else {
        const t = _.cloneDeep(this.route.arrivalTime).add(this.place.visit, 'minutes')
        return t ? t.format("HH:mm") : ''
      }
    },
    routeArrivalDate: function () {
      if (this.place.checkIn !== undefined) {
        const t = moment(this.place.checkIn)
        return t
      } else {
        const t = _.cloneDeep(this.route.arrivalTime)
        return t
      }
    },
    nextDepartureDate: function () {
      const t = moment(this.place.checkIn).add(this.place.visit, 'minutes')
      return t
    }
  },
  methods: {
    toggleEditMenu: function () {
      this.showEditMenu = !this.showEditMenu
    },
    onChangeVisit: function () {
      this.showEditMenu = false
      this.changeVisit()
    },
    onDeleteDestination: function () {
      this.showEditMenu = false
      this.deleteDestination()
    },
    showMap: function () {
      const location = this.place.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'] } })
    },
    inJapan: function () {
      if (this.place.location.longitude > 0) {
        return true
      } else {
        return false
      }
    },
    isFlight: function () {
      if (this.route.course.Route.Point[0].GeoPoint.longi_d > 0 && this.route.course.Route.Point[this.route.course.Route.Point.length - 1].GeoPoint.longi_d < 0 ) {
        return true
      } else if (this.route.course.Route.Point[0].GeoPoint.longi_d < 0 && this.route.course.Route.Point[this.route.course.Route.Point.length - 1].GeoPoint.longi_d > 0 ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
